<!--人文美育-视频库管理-->
<template>
    <div class="app-container" >
        <div class="base-create-container">
            <div class="form-box">
                <el-row style="height: 40px">
                    <el-col style="height: 40px" :span="8"></el-col>
                    <el-col style="height: 40px" :span="8">
                        <div class="head-container-top">五馆合一</div>
                    </el-col>
                    <el-col style="height: 40px" :span="8">
                        <el-form-item class="pull-right">
                            <el-input v-model="keyword" placeholder="请输入关键字" class="input-with-select">
                                <template #append>
                                    <el-button type="primary" @click="handleQuery" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>

            <div class="museum-container">
                <div class="museum-item">
                    <div class="museum-img" @click="viewMuseum('1')">
                        <img alt="" class="img-100" src="../../assets/museum/whg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" @click="viewMuseum('2')">
                        <img alt="" class="img-100" src="../../assets/museum/ysg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" @click="viewMuseum('3')">
                        <img alt="" class="img-100" src="../../assets/museum/kjg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" @click="viewMuseum('4')">
                        <img alt="" class="img-100" src="../../assets/museum/bwg.jpg">
                    </div>
                </div>
                <div class="museum-item">
                    <div class="museum-img" @click="viewMuseum('5')">
                        <img alt="" class="img-100" src="../../assets/museum/tsg.jpg">
                    </div>
                </div>
            </div>
            <div class="head-container" style="padding-top: 10px;">
                跨学科融合
            </div>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                     @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学段">
                            <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="年级">
                            <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="学科">
                            <el-select clearable @change="queryClassLibrary" v-model="queryParams.subjectKey" placeholder="请选择学科">
                                <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                           :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.className" placeholder="请输入教程名称" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQueryClass" type="primary" style="background-color: #3b62f8;color: #fff" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="book-container">
                <div class="book-item" v-for="item in libraryList">
                    <div class="book-one" @click="viewSubjectFusion(item)">
                        <div class="book-img">
                            <img alt="" class="img-100" :src="item.coverUrl">
                        </div>
                        <div class="book-title">
                            {{ item.className }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { listClassLibrary } from "@/api/admin/classLibrary";
import {serviceUrl} from "@/utils/global";
import {queryDict} from "@/api/admin/public";

export default {
    name: "humanityLibraryManage",
    components: {},
    data() {
        return {
            serviceUrl,
            keyword:'',
            subjectList: [],
            periodList: [],
            gradeList: [],
            libraryList: [],
            queryParams: {
                className: '',
                periodKey: '1',
                gradeKey: '',
                subjectKey: '',
            },
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryDict();
        this.queryClassLibrary();
    },
    mounted(){},
    methods: {
        queryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data.code === 1) {
                    this.periodList = res.data.data;
                    this.changePeriod();
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.queryClassLibrary()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.queryClassLibrary()
        },
        queryClassLibrary(){
            listClassLibrary(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.libraryList = res.data.data;
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        handleQueryClass(){
            this.queryClassLibrary();
        },
        handleQuery(){
            this.$router.push({
                path: "/searchHumanityVideo",
                query: {
                    keyword: this.keyword,
                }
            });
        },
        viewSubjectFusion(item){
            this.$router.push({
                path: "/subjectFusion",
                query: {
                    sign: item.classId,
                }
            });
        },
        viewMuseum(mk){
            this.$router.push({
                path: "/museumCourse",
                query: {
                    museumkey: mk,
                }
            });
        }
    }
}

</script>

<style scoped>
.base-create-container{
    width: 100%;
    height: calc(100vh - 95px);
    background-color: #fff;
    overflow-y: auto!important;
    padding-bottom: 10px;
    padding-top: 5px;
    font-family: sans-serif;
}
.form-box{
    padding: 10px 20px 0 0;
    height: 40px;
}
.head-container-top{
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 18px;
    color: #121212;
    line-height: 30px;
    font-weight: bold;
}
.head-container{
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 18px;
    color: #121212;
    line-height: 40px;
    font-weight: bold;
}
.museum-container{
    width: 100%;
    height: calc(100% - 50px);
    padding: 0 30px 0 30px;
    box-sizing: border-box;
    display: flex;
}
.museum-item{
    width: 20%;
    height: 100%;
    padding: 0 12px 0 12px;
    box-sizing: border-box;
    display: grid; place-items: center;
}
.museum-img{
    width: 100%;
    cursor: pointer;
    border: 1.5px solid #f1f1f1;
}
.book-container{
    width: 100%;
    height: auto;
    padding: 20px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap!important;
}
.book-item{
    width: 20%;
    height: 100%;
    padding: 0 20px 10px 20px;
    box-sizing: border-box;
}
.book-one{
    width: 100%;
    height: 100%;
    padding: 8px;
    border: 1.5px solid #f1f1f1;
}
.book-one:hover{
    border: 1.5px solid #3b62f8!important;
    color: #3b62f8!important;
    font-weight: bold;
}
.book-img{
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.book-title{
    height: 44px;
    font-size: 15px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    padding: 0 5px 5px 5px;
    cursor: pointer;
}
</style>